import type { TextFieldProps } from '@mui/material';
import { MenuItem, TextField } from '@mui/material';
import { forwardRef } from 'react';

import { useFieldContext } from '@/hooks/useFieldContext';

type StyledSelectProps = {
  options: { value: string; label: string }[];
} & Omit<TextFieldProps, 'type' | 'select'>;

export const SelectField = forwardRef<HTMLInputElement, StyledSelectProps>(({ options, ...props }, ref) => {
  const field = useFieldContext<string>();

  let error: string | undefined;
  if (typeof field.state.meta.errors[0] === 'string') {
    [error] = field.state.meta.errors;
  } else if (field.state.meta.errors[0] && 'message' in field.state.meta.errors[0]) {
    error = field.state.meta.errors[0].message;
  }

  return (
    <TextField
      ref={ref}
      fullWidth
      select
      error={!!field.state.meta.errors.length}
      helperText={error}
      name={field.name}
      onBlur={field.handleBlur}
      onChange={(event) => field.handleChange(event.target.value)}
      value={field.state.value ?? ''}
      {...props}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
});
